export function getAdminInfo(job) {
    let dateText = " ";
    let date = " ";
    let popup = "No info available";

    if (job.adminStatus === "UNAPPROVED") {
        dateText = "Enquiry received: ";
        date = job.dates.enquiryReceived.slice(8, 10) + "/" + job.dates.enquiryReceived.slice(5, 7) + "/" + job.dates.enquiryReceived.slice(0, 4);
        popup = "New";
    } else if (job.adminStatus === "APPROVED") {
        dateText = "Enquiry approved: ";
        date = job.dates.enquiryApproved;
        popup = "Approved";
    }

    return [dateText, date, popup];

}